import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { SpPageAccessDeniedComponent } from './sp-page-access-denied/sp-page-access-denied.component';
import { SpPageMaintenanceComponent } from './sp-page-maintenance/sp-page-maintenance.component';
import { SpPageNotFoundRedirectComponent } from './sp-page-not-found-redirect/sp-page-not-found-redirect.component';
import { SpPageSomethingWrongComponent } from './sp-page-something-wrong/sp-page-something-wrong.component';
import { SpPageRoutingModule } from './sp-page-routing.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import {SpPageErrorComponent} from './sp-page-error/sp-page-error.component';
import { SpPageUserBlockedComponent } from './sp-page-user-blocked/sp-page-user-blocked.component';
import { SpPageSharedExpiredComponent } from './sp-page-shared-expired/sp-page-shared-expired.component';

@NgModule({
  declarations: [
    SpPageAccessDeniedComponent,
    SpPageMaintenanceComponent,
    SpPageNotFoundRedirectComponent,
    SpPageSomethingWrongComponent,
    SpPageUserBlockedComponent,
    SpPageSharedExpiredComponent
  ],
  imports: [
    SpPageRoutingModule,
    CommonModule,
    MatTooltipModule,
    SpPageErrorComponent
  ],
  exports: [
    SpPageMaintenanceComponent
  ]
})
export class SpPageModule {}
